import * as React from "react";
import { Icon } from "../Icon/icon";
import { DelayedRender } from "../DelayedRender/DelayedRender";
export interface InputInfoProps {
  infoText?: string;
  delayRender?: number;
}

const DEFAULT_DELAY: number = 250;

/**
 * Renders the input info of a field with a delay.
 */
export function InputInfo(props: InputInfoProps) {
  const delayRender =
    typeof props.delayRender === "undefined"
      ? DEFAULT_DELAY
      : props.delayRender;
  return (
    props.infoText && (
      <DelayedRender delay={delayRender}>
        <React.Fragment>
          <span className="info-message">
            <Icon iconType="Info" className="form-summary__not-valid" />
            <span role="alert">{props.infoText}</span>
          </span>
        </React.Fragment>
      </DelayedRender>
    )
  );
}
